namespace GeniuzPOS.Purchase {
    export enum VatFgstatus {
        notvat = 0,
        vat = 1
    }
    Serenity.Decorators.registerEnumType(VatFgstatus, 'GeniuzPOS.Purchase.VatFgstatus');
}
